export default __webpack_public_path__ + "static/media/avatar_male.1800d6d1.jpg";